module.exports = __webpack_public_path__ + "static/media/landingCollaborator5.43bb0cce.jpg";